// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__3rMA8","Element":"List_Element__1sKsI","inline":"List_inline__2MzOx"};